export { default } from './assignInWith.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/extendWith.js
// module id = 634
// module chunks = 67